// extracted by mini-css-extract-plugin
export default {"editArea":"editArea___VMGKt","top":"top___yQGJO","footer":"footer___hWuYC","tip":"tip___Ch2sd"};